<template>
  <div>
    <div
      class="relative col-span-1 mb-2 flex aspect-default h-fit w-full items-center justify-center overflow-hidden rounded-xl bg-secondary md:row-span-2"
    />
    <div class="mx-3 mb-2 h-6 w-3/4 rounded-xl bg-secondary" />
    <ul class="flex h-fit flex-row flex-wrap gap-2 md:col-span-1">
      <li
        v-for="item in 3"
        :key="item"
        class="flex h-fit flex-col gap-y-1 rounded-xl border border-primary !bg-transparent !p-4 transition-all lg:shadow-none"
      >
        <div class="h-6 w-14 rounded-lg bg-secondary" />
        <div class="h-6 w-14 rounded-lg bg-secondary" />
      </li>
    </ul>
  </div>
</template>
